module.exports = __webpack_public_path__ + "img/cx_c1c2c3.png";